import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

import { fireTrack } from "@swa-ui/analytics";
import { Link } from "@swa-ui/core";
import { Toast } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./ChaseFriendReferral.module.scss";

export const ChaseFriendReferral = (props) => {
  const [toastVisible, setToastVisible] = useState(false);
  const handleCopyClick = useCallback(() => {
    navigator.clipboard.writeText(props.referralUrl);
    fireTrack("squid", { page_description: "link: refer a friend copy link" });
    setToastVisible(true);
  }, [props.referralUrl]);
  const handleToastClose = useCallback(() => {
    setToastVisible(false);
  }, []);

  useEffect(() => {
    let timer;

    if (toastVisible) {
      timer = setTimeout(() => {
        setToastVisible(false);
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [toastVisible]);

  return (
    <div className={styles.chaseFriendReferralContainer}>
      <div className={styles.chaseFriendReferralText}>{i18n("ReferYourFriend_URL_TEXT")}</div>
      <div className={styles.chaseFriendReferralUrl}>{props.referralUrl}</div>
      <div className={styles.chaseFriendReferralVerbiage}>
        {i18n("ReferYourFriend_Legal_Verbiage")}
      </div>
      <div className={styles.chaseFriendReferralCopyLink}>
        <Link {...getCopyLinkProps()}>{i18n("ReferYourFriend_COPY_URL_LINK")}</Link>
      </div>
      <Toast {...getToastProps()} />
    </div>
  );

  function getCopyLinkProps() {
    return {
      className: styles.chaseReferralUrlCopyLink,
      emphasis: false,
      onClick: handleCopyClick,
      styleType: "link",
    };
  }

  function getToastProps() {
    return {
      children: i18n("ReferYourFriend_COPIED_TOAST_MESSAGE"),
      messageProps: {
        styleType: "success",
      },
      on: toastVisible,
      onClose: handleToastClose,
      width: "small",
    };
  }
};

ChaseFriendReferral.propTypes = {
  referralUrl: PropTypes.string.isRequired,
};
